<template>
    <div class="arrow-back-wrapper ion-text-start ion-padding-start ion-padding-top">
        <img class="back-arrow icon-img" src="@/assets/icon-images/arrow-left.png" @click="back" />
    </div>
</template>

<script>
export default {
    name: 'BackArrow',
    methods: {
        back: function() {
            this.$router.back()
        }
    }
}
</script>

<style lang="scss" scoped>
.arrow-back-wrapper {
    z-index: 1;
}

#app[dir='rtl'] .back-arrow {
    transform: rotate(180deg);
}
</style>
